import Vue from 'vue'
import { catalogMonetary } from '@/util/catalog'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const displacementContent = (data) => {
  const displacement =
    !data.additionals.length >= 1 || !data.additionals[0].value > 0
      ? 0
      : data.additionals[0].value

  return `
    <h6 class="text-uppercase grey--text">
      ${translate(area + 'displacement')}
    </h6>
    <p class="body-2 mb-3">
      ${catalogMonetary(displacement)}
    </p>
  `
}

export default displacementContent
